// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"247":"Recommendations-RecommendationsContainer","873":"SavedSearch-Container-SavedSearchesContainer"}[chunkId] + "-" + {"247":"13337d42f50968278f78","873":"19bbc5500219961bc583"}[chunkId] + ".css";
};